import { isDevMode } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EnvironmentType } from '../../_types/environment-type.type';

const addSentryReplayIntegration = (sentry: typeof import('@sentry/angular')) => {
  const isProd = environment.environmentType === EnvironmentType.PROD;
  const integrationConfig = {
    maskAllInputs: isProd && false,
    maskAllText: isProd && false,
    maxReplayDuration: isProd ? 15000 : 10000,
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => sentry.addIntegration(sentry.replayIntegration(integrationConfig)));
  } else {
    setTimeout(() => sentry.addIntegration(sentry.replayIntegration(integrationConfig)), 1000);
  }
};

export const initSentry = async () => {
  if (isDevMode()) return;

  const sentry = await import('@sentry/angular');

  sentry.init({
    dsn: environment.sentryDsn,
    replaysSessionSampleRate: environment.environmentType === EnvironmentType.PREP ? 1 : 0,
    replaysOnErrorSampleRate: 1,
    environment: environment.environmentType,
  });

  addSentryReplayIntegration(sentry);
};
